import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}
  },
  mutations: {
    SETUSERINFO (state, usrinfo) {
      state.userInfo = usrinfo
      // console.log(state.userInfo)
    }
  },
  actions: {
    setUsrinfo (context, usrinfo) {
      context.commit('SETUSERINFO', usrinfo)
    }
  }
})
